import { IInvoiceRow } from "../service";

export const selectorInvoiceRowClientName = (invoice: IInvoiceRow) => {
  const name =
    invoice.primaryName ||
    invoice.client?.profile?.company?.name ||
    invoice.client?.profile?.company?.legalBusinessName ||
    invoice.clientCompany ||
    invoice.clientName;

  const primaryName = name ? name : invoice.clientEmail;

  const secondaryName = invoice.secondaryName
    ? invoice.secondaryName
    : name
    ? invoice.clientEmail
    : undefined;

  return {
    primaryName,
    secondaryName
  };
};
